import { render, staticRenderFns } from "./no.vue?vue&type=template&id=31ef5dce&scoped=true&"
var script = {}
import style0 from "./no.vue?vue&type=style&index=0&id=31ef5dce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ef5dce",
  null
  
)

export default component.exports